// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".AttachmentEntityConfig__container___2m_tJ{display:flex;padding:20px}\n", ""]);
// Exports
exports.locals = {
	"container": "AttachmentEntityConfig__container___2m_tJ"
};
module.exports = exports;
